import '../stylesheets/main.scss';

import htmx from 'htmx.org';
import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';

// Alpine.js directives
// See https://alpinejs.dev/advanced/extending#custom-directives
import ResizeObserverDirective from './directives/resizeobserver';

// Alpine.js components
// See https://alpinejs.dev/globals/alpine-data#registering-from-a-bundle
import PasswordComponent from '../components/password/javascripts/index';
import ScrollContainerComponent from '../components/scroll-container/javascripts/index';
import FileUploadComponent from '../components/file-upload/javascripts/index';
import VideoComponent from '../components/video/javascripts/index';
import DialogComponent from '../components/dialog/javascripts/index';
import TabsComponent from '../components/tabs/javascripts/index';
import HeaderComponent from '../components/header/header';
import SectionComponent from '../components/section/javascripts';
import ChartPieComponent from '../components/chart-pie/javascripts';
import ChartBarComponent from '../components/chart-bar/javascripts';
import ChartLineComponent from '../components/chart-line/javascripts';
import GalleryComponent from '../components/gallery/javascripts';
import ImageComponent from '../components/image-component/javascripts';
import StageComponent from '../components/stage/javascripts';
import TableComponent from '../components/table/javascripts';
import FooterComponent from '../components/footer/javascripts';

// Alpine.js initialization
// See https://alpinejs.dev/essentials/installation#as-a-module
window.Alpine = Alpine;

// htmx initialization
// See https://htmx.org/docs/#webpack
window.htmx = htmx;

Alpine.directive('resizeobserver', ResizeObserverDirective);

Alpine.plugin(focus)

Alpine.data('Password', PasswordComponent);
Alpine.data('ScrollContainer', ScrollContainerComponent);
Alpine.data('FileUpload', FileUploadComponent);
Alpine.data('Video', VideoComponent);
Alpine.data('Header', HeaderComponent);
Alpine.data('Dialog', DialogComponent);
Alpine.data('Tabs', TabsComponent);
Alpine.data('Section', SectionComponent);
Alpine.data('ChartPie', ChartPieComponent);
Alpine.data('ChartBar', ChartBarComponent);
Alpine.data('ChartLine', ChartLineComponent);
Alpine.data('Gallery', GalleryComponent);
Alpine.data('Fullscreen', ImageComponent);
Alpine.data('Stage', StageComponent);
Alpine.data('Table', TableComponent);
Alpine.data('Footer', FooterComponent);

Alpine.start();

// All links with target="_blank" attribute should have an attribute rel="noopener". This has performance and security reasons https://developers.google.com/web/tools/lighthouse/audits/noopener
document.querySelectorAll("[target='_blank']").forEach((link) => {
  link.setAttribute('rel', 'noopener');
});
